'use es6';

import { Map as ImmutableMap, Record } from 'immutable';
const DEFAULTS = {
  listId: 0,
  metaData: new ImmutableMap(),
  name: '',
  text: '',
  value: 0
};
export default class List extends Record(DEFAULTS) {
  static fromJS(data) {
    return List.fromBatchJS(data.list);
  }

  static fromBatchJS(data) {
    const {
      listId,
      metaData,
      name
    } = data;
    return new List({
      listId,
      metaData: new ImmutableMap(metaData),
      name,
      text: name,
      value: listId
    });
  }

}